import { CheckoutProduct } from '../../../../common/payment/products/productTypes';

import { CHECKOUT_NAVIGATION_STACK, CHECKOUT_PRODUCTS_ROUTE, CHECKOUT_STATE } from './checkoutConstants';

export const getProductPricingRoute = (product: CheckoutProduct): string => {
    return `${CHECKOUT_PRODUCTS_ROUTE}/${product.slug || product._id}`;
};

export const clearCheckoutState = () => {
    localStorage.removeItem(CHECKOUT_STATE);
    localStorage.removeItem(CHECKOUT_NAVIGATION_STACK);
};
